import { TEXT_SEARCH_FIELD_ID } from '../components/constants';
import { AutocompleteOptions, SearchBlock } from '../types';

/** The blocks in `param`, the `history` query param's value, or the default ones when it holds none. */
export function parseInitialSelectedBlocks<T, TAutocompleteState>(
    config: Pick<AutocompleteOptions<T, TAutocompleteState>, 'defaultSelectedBlocks'>,
    param: string | undefined,
): SearchBlock<T>[] {
    const fromUrl = parseParam<T>(param);
    if (fromUrl.length > 0) {
        return fromUrl;
    }
    return config.defaultSelectedBlocks ?? [];
}

function parseParam<T>(param: string | undefined): SearchBlock<T>[] {
    if (!param) {
        return [];
    }
    try {
        const searchBlocks = JSON.parse(param);
        if (!Array.isArray(searchBlocks)) {
            return [];
        }
        return searchBlocks;
    } catch {
        return [{ field: TEXT_SEARCH_FIELD_ID, op: 'like', parameter: param }];
    }
}
